import React from "react";
import "./Pucked.css";
import { appsData } from "../data/appsData";

const app = appsData.pucked;

export default function Pucked() {
  return (
    <div className="pucked-container">
      {/* HEADER */}
      <header className="pucked-header">
        <div className="pucked-header-inner">
          <a href="/" title="Back to main site" className="pucked-back-btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
            <span>Tilbo Apps</span>
          </a>

          <div className="pucked-header-center">
            <img
              src={app.iconPage}
              className="pucked-logo-sm"
              alt="Pucked logo"
            />
            <span className="pucked-app-title">{app.name}</span>
          </div>

          <div className="pucked-header-spacer" />
        </div>
      </header>

      {/* HERO SECTION */}
      <section className="pucked-hero">
        <div className="pucked-hero-badge">Smart Espresso Tracker</div>
        <h1 className="pucked-hero-title">
          Master Every Brew. <br />
          <span className="pucked-gradient-text">Dial In Perfection.</span>
        </h1>
        <p className="pucked-hero-subtitle">
          Track extractions, analyze flow profiles, manage your coffee bean
          collection, and receive AI-powered barista feedback to perfect every
          shot.
        </p>

        <div className="pucked-buttons-wrap">
          <StoreButtons />
        </div>
      </section>

      {/* SCREENSHOTS SHOWCASE */}
      <section className="pucked-showcase">
        <div className="pucked-showcase-grid">
          {app.screenshots.map((src, index) => (
            <div className="pucked-screenshot-card" key={index}>
              <img
                src={src}
                alt={`Pucked app screenshot ${index + 1}`}
                className="pucked-screenshot-img"
              />
            </div>
          ))}
        </div>
      </section>

      {/* FEATURES SECTION */}
      <section className="pucked-features">
        <h2 className="pucked-section-title">
          Built for Specialty Coffee Enthusiasts
        </h2>

        <div className="pucked-features-grid">
          <div className="pucked-feature-card">
            <div className="pucked-feature-icon">📊</div>
            <h3>Visual Extraction Data</h3>
            <p>
              Log yields, ratios, and shot times. Analyze extraction graphs to
              spot channeling, fast flow, or inconsistency in a glance.
            </p>
          </div>

          <div className="pucked-feature-card">
            <div className="pucked-feature-icon">⚙️</div>
            <h3>Complete Setup Tracking</h3>
            <p>
              Manage your entire coffee bar setup. Pair specific grinders,
              machines, baskets, and bean origins to every log.
            </p>
          </div>

          <div className="pucked-feature-card">
            <div className="pucked-feature-icon">📈</div>
            <h3>Track & Analyze</h3>
            <p>
              Compare current shots against previous brews. Uncover sweet spots
              in roast ages and grind settings over time.
            </p>
          </div>

          <div className="pucked-feature-card">
            <div className="pucked-feature-icon">🤖</div>
            <h3>AI Barista Feedback</h3>
            <p>
              Diagnose under/over extraction instantly. Get actionable dial-in
              advice to tweak grind sizes and ratios with confidence.
            </p>
          </div>
        </div>
      </section>

      {/* CTA BANNER */}
      <section className="pucked-cta-card">
        <h2>Ready to Upgrade Your Daily Workflow?</h2>
        <p>Download Pucked today and never waste a good coffee bean again.</p>
        <div className="pucked-buttons-wrap">
          <StoreButtons />
        </div>
      </section>

      {/* FOOTER */}
      <footer className="pucked-footer">
        <div className="pucked-footer-inner">
          <div className="pucked-footer-brand">
            <img
              src={app.iconPage}
              className="pucked-logo-xs"
              alt="Pucked icon"
            />
            <span>Pucked by Tilbo Apps</span>
          </div>

          <div className="pucked-footer-links">
            <a href={app.privacyLink} className="pucked-footer-link">
              Privacy Policy
            </a>
            <span className="pucked-dot">•</span>
            <a href={app.termsLink} className="pucked-footer-link">
              Terms of Use
            </a>
          </div>

          <p className="pucked-copyright">
            © {new Date().getFullYear()} Tilbo Apps. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

function StoreButtons() {
  return (
    <>
      <a
        href={app.appStoreLink}
        target="_blank"
        rel="noopener noreferrer"
        className="pucked-store-link"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/9/91/Download_on_the_App_Store_RGB_blk.svg"
          className="pucked-store-btn"
          alt="Download on the App Store"
        />
      </a>

      <a
        href={app.playStoreLink}
        target="_blank"
        rel="noopener noreferrer"
        className="pucked-store-link"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
          className="pucked-store-btn"
          alt="Get it on Google Play"
        />
      </a>
    </>
  );
}
